import { useUserData } from 'Foundation/User/UserContext';
import { useEffect, useRef, useState } from 'react';
import { attachGoalsToLinks } from 'Utilities/GoalManager';
import { StringHelper } from 'Utilities/StringHelper';

type IRichText = {
  content: string;
  className?: string;
  onTileRefresh?: () => void;
};

export default function RichText({ content, className, onTileRefresh }: IRichText) {
  const container = useRef<HTMLDivElement>(null);
  const [text, setText] = useState<string>(content);
  const { userData } = useUserData();

  useEffect(() => {
    if (text && userData) {
      setText(StringHelper.replaceTokens(text, userData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, userData?.selectedStatCodeData.SubStat]);

  useEffect(() => {
    if (container.current) attachGoalsToLinks(container.current.querySelectorAll('a[goal]'), onTileRefresh);
  }, [onTileRefresh]);

  return <div ref={container} className={className} dangerouslySetInnerHTML={{ __html: text }}></div>;
}
